<template>
    <div class="restricted-block restricted-sign-in-up mt-5">
        <div class="restricted-contant">
            <div class="contant">
                <span v-html="svg('lock-post')"></span>
                <h2>{{ $t('i18n.contentIsLocked') }}</h2>
                <div class="row">
                    <div class="col-md-6">
                        <div class="cta">
                            <h4>{{ $t('i18n.alreadyHaveAccount') }}</h4>
                            <a class="btn btn-primary" :href="login">
                                {{ $t('i18n.login') }}
                            </a>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="cta">
                            <h4>{{ $t('i18n.firstTimeUser') }}</h4>
                            <a class="btn btn-primary" :href="register">
                                {{ $t('i18n.register') }}
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    computed: {
        login: function () {
            return this.$variables.login_url
        },
        register: function () {
            return this.$variables.register_url
        }
    },
}
</script>
